import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function CommunityInnerpageBanner({ bannerImage, bannerTitle }) {


  return (
    <div
      className="common-banner-sec common-flex-center community-page-banner"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + bannerImage
          })`,
      }}
    >
      <div className="overlay"></div>
      <Container fluid>
        <Row className="common-flex-center">
          <Col md={8}>
            <div className=" ">
              <h1 className="common-head whiteColor">
                {bannerTitle}
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CommunityInnerpageBanner;
